import React from "react";
import { Tooltip, IconButton, Avatar, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { appColors } from "../../../constants/theme";
import { getPublicFileUrl } from "../../../utils/storedFile";

const CustomProfileMenuButton = ({
  openProfileMenu,
  handleClickProfileMenu,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { firstName, lastName, profilePhotoName } = useSelector((state) => state.auth.user);
  const profileImage = getPublicFileUrl(profilePhotoName);
  const size = isMobile ? 36 : 50;

  return (
    <Tooltip title={t("account_settings")}>
      <IconButton
        onClick={handleClickProfileMenu}
        size="small"
        sx={{ ml: { xs: 0, md: 1 } }}
        aria-controls={openProfileMenu ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openProfileMenu ? "true" : undefined}
      >
        <Avatar
          src={profileImage || undefined}
          sx={{
            width: size,
            height: size,
            background: appColors.primary,
            color: "white",
            fontSize: isMobile ? "0.85rem" : "1.1rem",
            fontWeight: 600,
            border: `2px solid ${appColors.gray200}`,
            "&:hover": {
              background: profileImage ? "transparent" : appColors.primaryDark,
              transform: "scale(1.05)",
              transition: "all 0.2s ease",
            },
          }}
        >
          {!profileImage && (
            <>
              {firstName?.charAt(0).toUpperCase()}
              {lastName?.charAt(0).toUpperCase()}
            </>
          )}
        </Avatar>
      </IconButton>
    </Tooltip>
  );
};

export default CustomProfileMenuButton;
